"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceEmails = void 0;
var USERNAME_BLACKLIST = [
    '=',
    '/',
    '?',
    '(',
    ')',
    '[',
    ']',
    '"',
    "'",
    '&',
    '@',
];
// use blacklist to support https://en.wikipedia.org/wiki/Internationalized_domain_name
var DOMAIN_BLACKLIST = [
    '!',
    '#',
    '$',
    '%',
    '&',
    "'",
    '*',
    '+',
    '/',
    '=',
    '?',
    '^',
    '_',
    '`',
    '{',
    '}',
    '(',
    ')',
    '[',
    ']',
    '|',
    '@',
    ';',
    ',',
    '\\',
    '"',
    '~',
];
var USERNAME_BLACKLIST_ESCAPED = regexEscape(USERNAME_BLACKLIST);
var DOMAIN_BLACKLIST_ESCAPED = regexEscape(DOMAIN_BLACKLIST);
function regexEscape(charArray) {
    return charArray.map(function (char) { return '\\' + char; }).join('');
}
function replaceEmails(text, replacer) {
    var emailRegex = new RegExp("[^\\s".concat(USERNAME_BLACKLIST_ESCAPED, "]+@[^\\s").concat(DOMAIN_BLACKLIST_ESCAPED, "]+\\.[^\\s").concat(DOMAIN_BLACKLIST_ESCAPED, "]+"), 'g');
    return text.replace(emailRegex, function (email) { return replacer(email); });
}
exports.replaceEmails = replaceEmails;
//# sourceMappingURL=replacers.js.map